export default {
  GET_AVAILABLE_DATES: 'tours/searchForm/dates/GET_AVAILABLE_DATES',
  GET_AVAILABLE_DATES_FAIL: 'tours/searchForm/dates/GET_AVAILABLE_DATES_FAIL',
  GET_AVAILABLE_DATES_SUCCESS: 'tours/searchForm/dates/GET_AVAILABLE_DATES_SUCCESS',
};
